import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';

export const verifyDateOfBirth = async ({
  appVersion,
  osType,
  osVersion,
  deviceId,
  dateOfBirth,
}: {
  dateOfBirth: string | undefined;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse<{ code: number }>>(
    'api:invoke',
    {
      method: 'POST',
      url: `${urls.apiUrl}verify-dob`,
      headers: {
        'X-User-Agent': generateUserAgentHeader({
          appVersion,
          osType,
          osVersion,
        }),
        'X-Device-ID': deviceId,
      },
      params: {
        include: 'patient',
      },
      data: {
        dateOfBirth,
      },
    },
  );

  if (result.data) {
    return result;
  }

  throw result;
};

export const setupPassword = async ({
  appVersion,
  osType,
  osVersion,
  deviceId,
  newPassword,
}: {
  newPassword: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse<null>>('api:invoke', {
    method: 'POST',
    url: `${urls.accountApiUrl}account/password`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      password: newPassword,
    },
  });

  return result;
};

export const forgotPassword = async ({
  appVersion,
  osType,
  osVersion,
  deviceId,
  phone,
}: {
  phone: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse>('api:invoke', {
    method: 'POST',
    url: `${urls.apiUrl}forgot-password`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    params: {
      include: 'patient',
    },
    data: {
      phone,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};

export const verifyPhoneCode = async ({
  otp,
  phoneNumber,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: {
  otp: string;
  phoneNumber: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<
    ApiResponse<{
      status: 'active' | 'inactive' | 'archived';
      accessToken: string;
      accessTokenType: string;
    }>
  >('api:invoke', {
    method: 'POST',
    url: `${urls.accountApiUrl}account/verify`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      phoneNumber,
      otp,
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};

export const requestPhoneCode = async ({
  phoneNumber,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: {
  phoneNumber: string;
  osType: string;
  osVersion: string;
  appVersion: string;
  deviceId: string;
}) => {
  const result = await mediator.request<ApiResponse>('api:invoke', {
    method: 'POST',
    url: `${urls.accountApiUrl}account`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      phoneNumber,
      country: 'us',
      language: 'en',
    },
  });

  if (result.data) {
    return result;
  }

  throw result;
};
